<template>
    <div class="bg-white">
        <CContainer>
            <div class="text-center">
            <img src="../assets/img/subscription/done.jpg" style="max-width:100%" />
            <h1 class="text-success"> <strong>Payment Successfull</strong></h1>
            <h4 class="text-black">Your payment have been processed !</h4>
            <h6 class="text-black">You can start login and explore Pickiddo Platform Dashboard</h6>
            <hr />
            <CRow>
                <CCol sm="6">  <CButton type="button" class="custom-btn-navy mt-2" size="lg" block @click="GoToPackage()">Back to Package</CButton></CCol>
                <CCol sm="6"><CButton type="button" class="custom-btn-success-subs mt-2" size="lg" block @click="GoToLogin()">Start Login</CButton></CCol>
            </CRow>
          
            <br />
            
        </div>
        </CContainer>
    </div>
</template>


<script>
import Vue from "vue";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
// Tell Vue to install the plugin.
Vue.use(VuejsDialog);
import _ from "lodash";


import AOS from "aos";
import "aos/dist/aos.css";

import Mainlayout from "../containers/AllHeaderLanding.vue";
import Footerlayout from "../containers/TheFooter.vue";

export default {
  name: "ProClass",
  components: {
    Mainlayout,
    Footerlayout,
  },
  data() {
    return {
    };
  },
  created() {
    AOS.init();
  },
  async mounted() {
    this.SubmitData()
  },
  methods: {
    GoToPackage() {
        window.open("https://www.pickiddo.com/PackageEduCenter");
    },
    GoToLogin() {
        window.open("https://ctr.pickiddo.com/#/Login");
    },
    SubmitData()
    {
      const formData = new FormData();
    
        formData.append("userId", this.$route.query.userId);
        formData.append("packageId", this.$route.query.packageId);

        console.log("us" + this.$route.query.userId)
        console.log("pa" + this.$route.query.packageId)

        return this.$API
          .post(this.$UpdatePaidSubscription, formData, {
            withCredentials: true,
          })
          .then((response) => {
            if (response.status == 200 && response.data != null) {
              //this.successModal = true;
             // this.$dialog.alert(response.data).then(function () {});
             window.open("https://ctr.pickiddo.com", "_self");
            }
          })
          .catch((error) => {
            if (error.response) {
              console.log(error.response.status);
              this.Error = true;
              this.Message = error;
              this.Message = "Error";
            }
          });
     },
      SubmitAdminSuccessfull() {
      const formData = new FormData();

      formData.append("Email", this.Email);
      formData.append("Username", this.Username);
      formData.append("PasswordHash", this.Password);
      formData.append("Description", this.Description);
      formData.append("Name", this.Organization);
      formData.append("PhoneNumber", this.Phone);
      formData.append("PackageId", this.$route.query.PackageId);

      return this.$API
        .post(this.$InsertAdminSuccess, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.billId = response.data;
            window.open("https://ctr.pickiddo.com", "_self");
          } else {
            this.Busy = false;
            this.$dialog
              .alert("Error to create packagess")
              .then(function () {});
          }
        })
        .catch((error) => {
          this.Busy = false;
          this.Loading = false;
          this.Error = true;
          this.Message = error.response.data.message;
        });
    },
    
    
}
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Montserrat&family=Poppins&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@100&wght@700&family=Montserrat&family=Poppins&display=swap");

.h1.h2.h3.h4.h5.h6 {
  font-family: Montserrat;
}
.c-app {
  font-family: Montserrat;
}
.c-app{
    background:#fff;
}
body{
    background:#fff;
}
html{
    background:#fff;
}
.h1,
.h2,
.h3,
.h4,
.h5,
.h6,
h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: "Montserrat";
}
</style>